module.exports = __webpack_public_path__ + "fonts/GT-Pressura-Bold.f34a48b.woff2";